module.exports = __webpack_public_path__ + "static/media/pf.f7f4584d.svg";